<template>
    <div>

        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 18px;">
            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2"  variant="secondary" @click="showAPreviewBankFile">Preview Bank File</b-button>
            <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" :disabled="selected.length == 0" variant="primary" @click="showAddToBankFile">Add to Bank File</b-button>


            <b-modal id="bv-modal-preview-bank-file" size="lg" dialog-class="w-1200"  hide-footer title="Preview Bank File">

            	<table class="table dataTable">
    		  <thead>
		    <tr class="table-head">
			<th>Name</th>
			<th>Employee Code</th>
			<th>Settlement ID</th>
			<th>Settlement Type</th>
			<th>Settlement Amount</th>
			<th>Settlement Date</th>
			<th>Remarks</th>
			<th>Action</th>

		    </tr>
    		  </thead>
    		  <tbody>
		    <tr class="hover-bg table-row border-bottom mx-2" v-for="settle in queue_on_bankfile" :key="settle.settlement_id">
			<td>{{ settle.name }}</td>
			<td>{{ settle.employee_code }}</td>
			<td>{{ settle.settlement_company_code }}</td>
			<td>{{ settle.settlement_type }}</td>
			<!-- <td>{{ settle.settlement_amount }}</td> -->  <!-- Rejwan: 24-04-2025 2 decimal -->
            <td>{{ formatMoney(settle.settlement_amount) }}</td> <!-- Rejwan: 24-04-2025 2 decimal -->

			<td>{{ settle.settle_date }}</td>
			<td>{{ settle.remark }}</td>
			<td class="text-center"><b-icon icon="trash-fill" aria-hidden="true" font-scale="1.5" @click="deleteRow(settle.settlement_id)"></b-icon></td> <!-- Mustafijur: 01-06-2026: Added text-center -->

		    </tr>
    		  </tbody>
            	</table>

            	<div>
                    <!-- Start: Rejwan: 23-04-2025 Awaiting Disbursement -->
            		<!-- <b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="secondary" @click="DownloadBankFile">Download Bank File</b-button>
            		<b-button class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="secondary" @click="SendBankFile">Send To Bank</b-button> -->
                    <b-button v-if="queue_on_bankfile.length > 0" class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="secondary" @click="DownloadBankFile">Download Bank File</b-button>
                    <!-- Start: Rejwan: 24-08-2026 -->
            		<!-- <b-button v-if="queue_on_bankfile.length > 0" class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="secondary" @click="SendBankFile">Send To Bank</b-button> -->
            		<b-button v-if="queue_on_bankfile.length > 0" class="border rounded bg-light py-1 px-5 mt-4 ml-2" variant="secondary" @click="SendBankFile">Disburse</b-button>
                    <!-- End: Rejwan: 23-04-2025 Awaiting Disbursement -->
                    <!-- End: Rejwan: 24-08-2026 -->
            	</div>


            </b-modal>
            <!-- <b-modal id="bv-modal-add-to-bank-file" size="lg" hide-footer title="Add to Bank File" :selected="selected"> -->
            <b-modal id="bv-modal-add-to-bank-file" size="lg" hide-footer title="Add to Bank File" :selected="selected" @hidden="onModalClose"> <!-- Rejwan: 16-02-2025 -->

            	<table class="table dataTable">
                    <thead>
                        <tr class="table-head">
                            <th>Name</th>
                            <th>Employee Code</th>
                            <th>Settlement ID</th>
                            <th>Settlement Type</th>
                            <th>Settlement Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="settle in adding_to_bankfile" :key="settle.id">
                            <td>{{ settle.name }}</td>
                            <td>{{ settle.employee_code }}</td>
                            <td>{{ settle.settlement_company_code }}</td>
                            <td>{{ settle.settlement_type }}</td>
                            <!-- <td>{{ settle.settlement_amount }}</td> --> <!-- Rejwan: 24-04-2025 2 decimal -->
                            <td>{{ formatMoney(settle.settlement_amount) }}</td> <!-- Rejwan: 24-04-2025 2 decimal -->
                            <td>{{ settle.settlement_status	 }}</td>
                        </tr>
                    </tbody>
            	</table>

                    <b-form @submit.stop.prevent="saveToBankFile">


                        <b-form-group id="settle_date-group" label="Settlement Date [YYYY-MM-DD]" class="required-field" label-for="settle_date">
                                            <b-input-group class="mb-3">
                                                <b-form-input id="settle_date" name="settle_date" v-model="fdata.settle_date" v-validate="{required:true, }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('settle_date')" aria-describedby="settle_date-feedback" data-vv-as="Date"></b-form-input>
                                                <b-input-group-append>
                                                <b-form-datepicker id="settle_date" button-only right locale="en-US" v-model="fdata.settle_date"></b-form-datepicker>
                                                </b-input-group-append>
                                                <b-form-invalid-feedback id="settle_date-feedback">{{ veeErrors.first('settle_date') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>


                                <b-form-group id="remark-group" label="Remark" label-for="remark" class="required-field">
                        <b-form-input id="remark" name="remark" v-model="fdata.remark" v-validate="{ required: true, min: 3 , alpha_spaces: true }" :state="validateState('remark')" aria-describedby="remark-feedback" data-vv-as="Remark"></b-form-input>
                        <b-form-invalid-feedback id="remark-feedback">{{ veeErrors.first('remark') }}</b-form-invalid-feedback>
                        </b-form-group>

                        <div class="full-width mt-2">
                        <b-button type="submit" variant="primary">Submit</b-button> <!-- //    Start: Rejwan: 24-08-2026 -->
                        </div>

                    </b-form>
            </b-modal>
        </div>
        <div v-if="custom_list.length>0">
            <common-list  :pageurl="this.$api_url" :checkbox="checkbox"  :is_pf="is_n_pf"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>
        </div>
        <div v-else>

            <div v-if="show_loader" class="list-no-data">
                <span class="d-block text-center">Looking for relevant data..</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
            <div v-else class="list-no-data">
                Looks like there is no employee to show.
            </div>

        </div>

        <pf-settlement-form-quick-view :pageurl="pageurl" :quick_view="quick_view" :action_type="action_type" :settlement_id="settlement_id" :employee_id="employee_id"  :employee_name="employee_name"  :key="settle_form_key"  v-on:childToParent="detailsReturn" ></pf-settlement-form-quick-view>
        <template v-if="history_key > 0">
            <!-- <bank-file-history :pageurl="$api_url" :instrument_id="settlement_id" :instrument_type="history_type" :key="history_key" ></bank-file-history> -->
            <bank-file-history :modal_id="'bank-history-disbursement-' + history_key" :pageurl="$api_url" :instrument_id="settlement_id" :instrument_type="history_type" :key="history_key" ></bank-file-history>
        </template>

    </div>
</template>
<script>
    export default{

        mounted() {

            this.showoverlay = false;
        },
        props: ['flg','pageurl','is_action'],
        components: {

        },
        data(){

            return {
                custom_list:[],  /* Data List */
                default_column:['name','employee_code'], /* Default Column List */
                appended_column:[

                    { value: "settlement_company_code", text: "Settlement ID",type: "text"},
                    { value: "settlement_type", text: "Settlement Type",type: "text"},
                    { value: "settlement_date", text: "Settlement Date",type: "date"},
                    // { value: "settlement_amount", text: "Settlement Amount",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                     { value: "settlement_amount", text: "Settlement Amount",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "application_status", text: "Status",type: "text"},


                    ],                   /* Appended Column List  and there title and type */
                primary_key:'settlement_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */
                list_key:0,
                is_n_pf:1,
                show_loader:false,
                settlement_id:0,
                settle_form_key:0,
                employee_id:0,
                employee_name:0,
                show_approval:0,
                quick_view:0,
                action_type:"",
                checkbox:1,
                history_key:0,
                history_type:2,
                selected : [],
                added : [],
                add_to_bank_file : [],
                adding_to_bankfile:[],
                fdata:{},
                queue_on_bankfile:[],

            }
        },
        methods:{
      	    deleteRow(settlement_id){

                let currentObj = this;
                let formData = new FormData();
                formData.append('settlement_id', settlement_id);
                axios.post(this.$api_url+'/pf/settl-delete-bankfile' , formData)
                        .then(function (response)
                        {

                        	this.getAddedToBankFileList(response.data);
                            this.getSettlementList(); // Rejwan: 18-06-2025 Awaiting Disbursement

                        }.bind(this))
                        .catch(function (error)
                        {
                        this.showoverlay = false;
                        currentObj.serverError(error);
                        });
            },
            detailsReturn:function()
            {
                this.$validator.reset();
                this.getSettlementList();
            },
            DownloadBankFile: function()
            {
                let currentObj = this;
                this.downloadBlobResponse(
                    axios.post(this.$api_url+'/pf/settl-download-bankfile', {}, { responseType: 'blob' }),
                    'loader' // your loader key in this component
                );
            },
            SendBankFile: function()
            {
                axios.post(this.$api_url+'/pf/settl-send-bankfile')
                .then(function (response)
                {
                    this.$bvToast.toast('Success', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
                    this.getSettlementList();

                }.bind(this))
                .catch(function (error)
                {
                this.showoverlay = false;
                currentObj.serverError(error);
                });
            },
            getAddedToBankFileList: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/pf/settl-add-bankfile').then(function(response){


                    let list = response.data;
                    let keys = Object.keys(list).map(Number);
                    this.added = keys;

                    this.queue_on_bankfile = [];
                this.added.forEach((settl, index) => {
                var x  = this.custom_list.find(item => item.settlement_id === settl);
                if (!this.queue_on_bankfile.includes(x)) {
                    x.settle_date = list[settl].settle_date;
                    x.remark = list[settl].remark;
                this.queue_on_bankfile.push(x);
                }
                });

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            showAddToBankFile:function()
            {

                if(this.selected.length > 0)
                {

                    console.log(this.selected);

                    this.adding_to_bankfile = [];
                    this.selected.forEach((settl, index) => {

                    var x  = this.custom_list.find(item => item.settlement_id === settl);

                    if (!this.adding_to_bankfile.includes(x) && !this.added.includes(settl)) {
                    this.adding_to_bankfile.push(x);
                    }
                    else
                    {
                        this.$bvToast.toast('Selected Settlement '+x.settlement_id+' already added', {
                                title: `Already Added`,
                                variant: 'warning',
                                solid: true
                            });
                    }

                });

                this.fdata = {};
                }

                if(this.adding_to_bankfile.length > 0)
                {
                    this.fdata = {}; // Rejwan: 18-06-2025 Awaiting Disbursement
                    this.$bvModal.show('bv-modal-add-to-bank-file');
                }
                else
                {
                    this.$bvToast.toast('Selected Settlement are already added', {
                                title: `Already Added`,
                                variant: 'warning',
                                solid: true
                            });
                }



            },


            saveToBankFile(e)
            {
                if(!this.checkNet()) return false;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }


                    e.preventDefault();
                    let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    formData.append('selected', this.selected);

                    //console.log(formData);



                    axios.post(this.$api_url+'/pf/settl-add-bankfile', formData)
                        .then(function (response)
                        {

                        this.getAddedToBankFileList();
                        //    Start: Rejwan: 24-08-2026
                        // this.$bvToast.toast('Saved!', {
                        //         title: `Success`,
                        //         variant: 'success',
                        //         solid: true
                        //     });

                        //     this.$bvModal.hide('bv-modal-add-to-bank-file');
                        //     this.getSettlementList();
                        if (response.data.errors && response.data.errors.length > 0) {
                            // show each error as a separate danger toast
                            response.data.errors.forEach(msg => {
                                this.$bvToast.toast(msg, {
                                    title: `Missing Bank Info`,
                                    variant: 'danger',
                                    solid: true,
                                    autoHideDelay: 8000,
                                });
                            });
                        }

                        if (response.data.inserted > 0) {
                            this.$bvToast.toast(response.data.inserted + ' settlement(s) added to bank file.', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                        }
                        //    End: Rejwan: 24-08-2026

                        this.$bvModal.hide('bv-modal-add-to-bank-file');
                        this.getSettlementList();
                        }.bind(this))
                        .catch(function (error)
                        {
                        this.showoverlay = false;
                        currentObj.serverError(error);
                        });


                });
            },


            showAPreviewBankFile:function()
            {
                this.$bvModal.show('bv-modal-preview-bank-file');
            },


            listReturn:function(data)
            {

                this.selected = data.selected;
                if(data.action_id==1)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id);
                    if(data.settlement_id > 0)
                    {
                        this.quick_view = 1;
                        this.action_type = "";
                        this.settlement_id = data.settlement_id;
                        this.employee_id = item.employee_id;
                        this.employee_name = item.name;
                        this.settle_form_key += 1;
                    }

                }
                if(data.action_id==2)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id);
                    if(data.settlement_id > 0)
                    {
                        this.quick_view = 0;
                        this.action_type = "hold";
                        this.settlement_id = data.settlement_id;
                        this.employee_id = item.employee_id;
                        this.employee_name = item.name;
                        this.settle_form_key += 1;
                    }

                }
                if(data.action_id==4)
                {
                    this.settlement_id = 0;
                    var item  = this.custom_list.find(item => item.settlement_id === data.settlement_id);
                    if(data.settlement_id > 0)
                    {
                        this.quick_view = 0;
                        this.settlement_id = data.settlement_id;
                        this.employee_id = item.employee_id;
                        this.employee_name = item.name;
                        this.history_key += 1;
                    }

                }
                // Start: Rejwan: 16-02-2025
	        if (data.action_id == 3) {

	             var x = this.custom_list.find(item => item.settlement_id === data.settlement_id);
                 this.selected = data.settlement_id; // Rejwan: 23-04-2025 Awaiting Disbursement
	             if (!this.adding_to_bankfile.includes(x) && !this.added.includes(data.settlement_id)) {
	                 this.adding_to_bankfile.push(x);
	             }
                this.fdata = {}; // Rejwan: 18-06-2025 Awaiting Disbursement
		        this.$bvModal.show('bv-modal-add-to-bank-file');

		}
		// End: Rejwan: 16-02-2025
            },
            // Start: Rejwan: 16-02-2025
            onModalClose: function() {
                this.adding_to_bankfile = [];
            },
            // End: Rejwan: 16-02-2025
            getSettlementList: function()
            {

                this.show_loader = true;
                let currentObj = this;
                let formData = new FormData();
                if(!this.checkNet()) return false;
                formData.append('list_type', 'awaiting_disbursement');
                axios.post(this.$api_url+'/pf/settlement/list', formData)
                .then(function (response)
                {

                    let temp_settle_list;
                    /* Assingning the Options */

                    currentObj.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                    /* Assingning the list */
                    temp_settle_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                    console.log(temp_settle_list);
                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

                    if(temp_settle_list.length > 0 )
                    {


                        temp_settle_list.forEach(element => {
                            let dop = [];
                            dop = dop.concat([{ label: 'Quick View' , value: 1 }]);
                            dop = dop.concat([{ label: 'Bank File History' , value: 4 }]);


                            if(element.locked != 1)
                            {
                                dop = dop.concat([{ label: 'On Hold' , value: 2 }]);
                                dop = dop.concat([{ label: 'Add to Bank File' , value: 3 }]);
                            }
                                element.actions = dop;
                            });



                    }
                    else
                    {
                        currentObj.blankmsg = "No employee found as leaver";
                    }

                    currentObj.custom_list = temp_settle_list;
                    currentObj.list_key = currentObj.list_key + 1;
                    currentObj.show_loader = false;

                    this.getAddedToBankFileList();


                }.bind(this))
                .catch(function (error)
                {
                    console.log(error);
                    currentObj.show_loader = false;
                });

            },
            overviewReturn:function()
            {
                this.$validator.reset();
                this.getSettlementList();
            },
        },
        created: function(){
            this.getSettlementList();


        },
        computed:
        {

        }
    }
</script>
